import React, { useContext } from 'react';

import { NavigationContext } from '../../../context/NavigationContext';
import { PageContext } from '../../../context/PageContext';
import { isPageSelected } from '../../../utils';
import { NavigationItem } from '../../NavigationItem';
import { Category } from '../Category';

import * as classes from './style.module.scss';

interface Props {
  pathname: string;
}

export const Content: React.FC<Props> = ({ pathname }) => {
  const { sidebarContents } = useContext(PageContext);
  const { open, closeNavigation } = useContext(NavigationContext);
  const handleClick = () => {
    if (open) closeNavigation();
  };

  if (!sidebarContents || !sidebarContents?.length) {
    return null;
  }

  return (
    <div className={classes.root}>
      {sidebarContents.map(content => {
        if ('path' in content) {
          return (
            <NavigationItem
              key={content.title}
              anchor={content.anchor}
              path={content.path}
              title={content.title}
              active={isPageSelected(content.path, pathname)}
              onClick={handleClick}
            />
          );
        }

        return (
          <Category
            key={content.title}
            title={content.title}
            defaultExpanded={content.defaultExpanded}
            collapsible={content.collapsible}
            sidebarPages={content.pages}
            pathname={pathname}
          />
        );
      })}
    </div>
  );
};
